import { inject } from "mobx-react";

function LogoutContainer(props){
	props.session.doLogout();
	return '';
}
export default inject('session')(LogoutContainer);
